import {createStore, applyMiddleware, compose} from "redux";
import {thunk} from "redux-thunk";

import rootReducer from "../reducers/index";

const middleware = applyMiddleware(thunk);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(middleware));

// Make store available globally for axios interceptor
window.store = store;

export {store};
